import styled from 'styled-components';
import { deviceHeight, deviceWidth } from '../../designs/devices';

export const Logo = styled.img`
position: absolute;
width: 146px;
height: 27.16px;
left: 27px;
top: 44px;
`;

export const Circles = styled.img`
position:absolute;
bottom:0px;
width:100%;
height:115px;

@media ${deviceHeight.mobileS} { 
    height:70px;
}
`;

export const IntroDiv = styled.div`
position:absolute;
top:160px;
width:100%;
display:flex;
flex-direction:column;
align-items:center;
`;

export const IntroHeader = styled.span`
position: static;
height: 48px;
top: 198px;
display:flex;
order:0;
font-family: Nunito;
font-style: normal;
font-weight: 800;
font-size: 40px;
line-height: 48px;
text-align: center;
color: #303645;
`;

export const IntroText = styled.span`
position: static;
display:flex;
height: 52px;
order:1;
margin-top: 11px;
font-family: Nunito;
font-style: normal;
font-weight: 600;
font-size: 16px;
line-height: 22px;
text-align: center;
color: #303645;
@media ${deviceWidth.mobileS} { 
    height:70px;
}
`;

export const LoginDots = styled.img`
position:static;
margin-top:62px;
display:flex;
order:2;
`;

export const RegisteredLink = styled.span`
position: static;
height: 18px;
margin-top:32px;
display:flex;
order:3;
font-family: Nunito;
font-style: normal;
font-weight: bold;
font-size: 16px;
line-height: 18px;
color: #454ADE;
`;

export const LoginButton = styled.button`
position:static;
width:90%;
height:48px;
margin-top:32px;
order:4;
outline:none;
background:#454ADE;
box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.05);
border:none;
font-family: Nunito;
font-style: normal;
font-weight: bold;
font-size: 16px;
line-height: 24px;
border-radius: 8px;
color:#FFFF;
`;

export const LoginHeaderDiv = styled.div`
position: absolute;
width:100%;
top: 44px;
display:flex;
flex-direction:row;
justify-content:flex-start;
align-items:center;
`;

// export const BackArrow = styled.img`
// position: static;
// width: 50px;
// height: 50px;
// `;

export const LoginHeader = styled.span`
position: static;
font-family: Nunito;
font-style: normal;
font-weight: bold;
font-size: 19px;
line-height: 100%;
color: #303645;
`;

export const Container = styled.div`
position:fixed;
width:100%;
height:100vh;
background-color:#FFFF;
z-index: 210;
`;

export const LoginText = styled.div`
position: absolute;
height: 17px;
top:80px;
left: 48px;
font-family: Nunito;
font-style: normal;
font-weight: 600;
font-size: 12px;
line-height: 140%;
color: #303645;
`;

export const PasswordDiv= styled.div`
position: absolute;
width:90%;
left:5%;
right:5%;
top: 170px;
display:flex;
flex-direction:row;
justify-content:space-between;
align-items:center;
`;

export const Input = styled.input`
position: absolute;
width:90%;
left:5%;
right:5%;
height: 44px;
top: 170px;
border:none;
font-family: Nunito;
font-style: normal;
font-weight: bold;
font-size: 16px;
line-height: 44px;
placeholderTextColor: #828999;
color:#303645;
text-decoration: none;
outline:none;
focus:none;
`;

export const Password = styled.input`
position:static;
width:100%;
outline:none;
focus:none;
border:none;
font-family: Nunito;
font-style: normal;
font-weight: bold;
font-size: 16px;
line-height: 44px;
placeholderTextColor: #828999;
color:#303645;
`;


export const LoginLine = styled.div`
position:absolute;
width:90%;
left:5%;
right:5%;
top:214px;
border: 1px solid #E1E5EE;
`;

export const ContinueButton = styled.div`
position: absolute;
width:90%;
left:5%;
height: 44px;
top: 228px;
background: #454ADE;
border:none;
box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.05);
border-radius: 6px;
font-family: Nunito;
font-style: normal;
font-weight: bold;
font-size: 16px;
line-height: 44px;
color:#FFFF;
display:flex;
flex-direction:row;
justify-content:center;
align-items:center;
`;

export const ErrorBox = styled.span`
position:absolute;
top:280px;
left 5%;
font-family: Nunito;
font-style: normal;
font-size: 12px;
color: #ff685f;
background: rgba(255, 215, 213, 0.2);
padding:2px 8px;
`;

export const GreenBox = styled(LoginText)`
background: linear-gradient(247.1deg, #2BCF76 0%, #2CB8A3 100%);
border-radius: 2px;
font-weight: 600;
color:#FFFF;
padding:2px 8px;
`;